/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalEndUserResponse
 */
export interface ExternalEndUserResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    mfaPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalEndUserResponse
     */
    status?: string | null;
}

/**
 * Check if a given object implements the ExternalEndUserResponse interface.
 */
export function instanceOfExternalEndUserResponse(value: object): value is ExternalEndUserResponse {
    return true;
}

export function ExternalEndUserResponseFromJSON(json: any): ExternalEndUserResponse {
    return ExternalEndUserResponseFromJSONTyped(json, false);
}

export function ExternalEndUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEndUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'mfaPhoneNumber': json['mfaPhoneNumber'] === undefined ? undefined : json['mfaPhoneNumber'] === null ? null : json['mfaPhoneNumber'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
    };
}

export function ExternalEndUserResponseToJSON(json: any): ExternalEndUserResponse {
    return ExternalEndUserResponseToJSONTyped(json, false);
}

export function ExternalEndUserResponseToJSONTyped(value?: ExternalEndUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'displayName': value['displayName'],
        'email': value['email'],
        'firstName': value['firstName'],
        'surname': value['surname'],
        'mfaPhoneNumber': value['mfaPhoneNumber'],
        'status': value['status'],
    };
}

